import React, { useState, useEffect } from 'react';
import AddressForm from './AddressForm';

const AddressGateModal = ({ isOpen, onClose, onComplete, initialValues = null }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      requestAnimationFrame(() => setVisible(true));
    } else {
      setVisible(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-[1001] animate-fade-in"
        onClick={onClose}
      />
      <div className={`fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-[1001] overflow-y-auto transition-transform duration-300 ease-spring ${visible ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900">{initialValues ? 'Edit address details' : 'Add address details'}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition"
              aria-label="Close"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <AddressForm
            initialValues={initialValues}
            onSubmit={onComplete}
            onCancel={onClose}
            submitLabel="Save and continue"
          />
        </div>
      </div>
    </>
  );
};

export default AddressGateModal;
